/**
 * PDP — Apodemia (iurop-product.liquid)
 *
 * - Add-to-cart AJAX (form principal y upsells "Combínalo con"): POST a
 *   /cart/add.js y dispara `cart:updated` → iurop-cart-drawer.js refresca y
 *   abre el sidecart (mismo patrón que shop-the-look).
 * - Cambio de variante: actualiza precio, compare-at, cuota seQura y el
 *   estado del aviso de stock (in/low/out) desde el JSON [data-pdp-variants].
 * - "Leer más" de la descripción (solo si el texto desborda el clamp).
 * - Reseña: clic/tecla expande (además del hover de escritorio, CSS).
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    var n = (cents / 100).toFixed(2).replace('.', ',');
    // Separador de miles con punto (es-ES)
    n = n.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return n + ' €';
  }

  // Con el sidecart fluido (IuropCart.add) el drawer se abre al instante con
  // la línea provisional; sin él, flujo clásico.
  function addToCart(items, previews) {
    if (window.IuropCart && window.IuropCart.add) {
      return window.IuropCart.add(items, previews || []);
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
        );
      });
  }

  function init(root) {
    // ----- Grabado ("Graba tu joya") -----
    // Estado del bloque + propiedades de línea. getEngrave() devuelve
    // { properties, extraVariant } para el añadir al carrito.
    var engraveEl = root.querySelector('[data-pdp-engrave]');
    var engrave = {
      state: { text: '', font: null, format: null, symbol: null },
      el: engraveEl,
    };
    if (engraveEl) {
      var eText = engraveEl.querySelector('[data-engrave-text]');
      var setActive = function (group, btn) {
        engraveEl.querySelectorAll(group).forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
      };
      var eCount = engraveEl.querySelector('[data-engrave-count]');
      var syncEngraveCount = function () {
        if (!eCount || !eText) return;
        var max = parseInt(eText.getAttribute('maxlength') || '20', 10);
        eCount.textContent = eText.value.length + '/' + max;
      };
      if (eText) {
        eText.addEventListener('input', function () {
          engrave.state.text = eText.value.trim();
          syncEngraveCount();
        });
        // Una sola línea: Enter no hace nada (ni salto ni submit).
        eText.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') e.preventDefault();
        });
      }
      engraveEl.querySelectorAll('[data-engrave-font]').forEach(function (b, i) {
        if (i === 0) engrave.state.font = b.getAttribute('data-value');
        b.addEventListener('click', function () {
          engrave.state.font = b.getAttribute('data-value');
          setActive('[data-engrave-font]', b);
          if (eText) eText.style.fontFamily = "'" + b.getAttribute('data-value') + "', 'EB Garamond', serif";
        });
      });
      engraveEl.querySelectorAll('[data-engrave-format]').forEach(function (b, i) {
        if (i === 0) engrave.state.format = b.getAttribute('data-value');
        b.addEventListener('click', function () {
          engrave.state.format = b.getAttribute('data-value');
          setActive('[data-engrave-format]', b);
        });
      });
      engraveEl.querySelectorAll('[data-engrave-symbol]').forEach(function (b) {
        b.addEventListener('click', function () {
          // Ilustración (imagen): selección única con toggle -> propiedad 'Símbolo'.
          if (b.hasAttribute('data-engrave-symbol-img')) {
            var wasOn = b.classList.contains('is-selected');
            engraveEl.querySelectorAll('[data-engrave-symbol-img]').forEach(function (x) {
              x.classList.remove('is-selected');
              x.setAttribute('aria-pressed', 'false');
            });
            if (!wasOn) {
              b.classList.add('is-selected');
              b.setAttribute('aria-pressed', 'true');
              engrave.state.symbol = b.getAttribute('data-value');
            } else {
              engrave.state.symbol = null;
            }
            return;
          }
          // Carácter (legacy): se inserta en el texto.
          if (!eText) return;
          var max = parseInt(eText.getAttribute('maxlength') || '20', 10);
          if (eText.value.length < max) {
            eText.value += b.getAttribute('data-value');
            engrave.state.text = eText.value.trim();
            syncEngraveCount();
            eText.focus();
          }
        });
      });
      // Tabs de categoría de ilustraciones.
      engraveEl.querySelectorAll('[data-engrave-cat]').forEach(function (b) {
        b.addEventListener('click', function () {
          var cat = b.getAttribute('data-engrave-cat');
          engraveEl.querySelectorAll('[data-engrave-cat]').forEach(function (x) {
            var on = x === b;
            x.classList.toggle('is-selected', on);
            x.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          engraveEl.querySelectorAll('[data-engrave-grid]').forEach(function (g) {
            g.hidden = g.getAttribute('data-engrave-grid') !== cat;
          });
        });
      });
    }
    var getEngrave = function () {
      var props = {};
      var extraVariant = null;
      var engToken = null;
      if (engraveEl && (engrave.state.text || engrave.state.symbol)) {
        var name = engraveEl.getAttribute('data-prop-text') || 'Grabado';
        if (engrave.state.text) props[name] = engrave.state.text;
        if (engrave.state.symbol) props['Símbolo'] = engrave.state.symbol;
        if (engrave.state.font) props['Fuente'] = engrave.state.font;
        if (engrave.state.format) props['Formato'] = engrave.state.format;
        var ev = engraveEl.getAttribute('data-engrave-variant');
        if (ev) {
          extraVariant = parseInt(ev, 10);
          // Token que liga la joya con su línea de servicio (+precio) en el
          // carrito: la de servicio no se borra suelta y se quita con la joya.
          engToken = 'eng-' + Date.now() + '-' + Math.floor(Math.random() * 100000);
          props['_engrave_id'] = engToken;
        }
      }
      return { properties: Object.keys(props).length ? props : null, extraVariant: extraVariant, engToken: engToken };
    };

    // ----- Avísame cuando esté disponible (Back in Stock de Klaviyo) -----
    // Alta con la API cliente de Klaviyo; el company_id se lee del script del
    // embed de Klaviyo (onsite). Klaviyo envía el email al reponer stock de la
    // variante mediante su flujo "Back in Stock".
    var notifyEl = root.querySelector('[data-pdp-notify]');
    var notifyForm = notifyEl && notifyEl.querySelector('[data-pdp-notify-form]');
    if (notifyForm) {
      var klaviyoCompany = function () {
        var sc = document.querySelector('script[src*="klaviyo.js?company_id="], script[src*="klaviyo.js?"][src*="company_id="]');
        var m = sc && sc.src.match(/company_id=([A-Za-z0-9]+)/);
        return m ? m[1] : '';
      };
      notifyForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var msg = notifyForm.querySelector('[data-pdp-notify-msg]');
        var btn = notifyForm.querySelector('button[type="submit"]');
        var emailInput = notifyForm.querySelector('[name="email"]');
        var consent = notifyForm.querySelector('[name="consent"]');
        var showMsg = function (t) { if (msg) { msg.textContent = t; msg.hidden = !t; } };
        showMsg('');
        if (!emailInput.checkValidity() || !emailInput.value) { emailInput.reportValidity(); return; }
        if (consent && !consent.checked) { showMsg(notifyEl.getAttribute('data-msg-consent') || ''); return; }
        var company = klaviyoCompany();
        var variantId = notifyEl.getAttribute('data-variant');
        if (!company || !variantId) { showMsg(notifyEl.getAttribute('data-msg-error') || ''); return; }
        btn.classList.add('is-loading');
        fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2025-01-15' },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: ['EMAIL'],
                profile: { data: { type: 'profile', attributes: { email: emailInput.value.trim() } } }
              },
              relationships: {
                variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
              }
            }
          })
        }).then(function (r) {
          if (!r.ok) throw new Error('klaviyo ' + r.status);
          notifyForm.hidden = true;
          var ok = notifyEl.querySelector('[data-pdp-notify-success]');
          if (ok) ok.hidden = false;
        }).catch(function () {
          showMsg(notifyEl.getAttribute('data-msg-error') || '');
        }).then(function () {
          btn.classList.remove('is-loading');
        });
      });
    }

    // ----- Form principal (AJAX → sidecart, sin recargar) -----
    var form = root.querySelector('form[action*="/cart/add"]');
    var mainBtn = root.querySelector('[data-pdp-add-main]');
    if (form && mainBtn) {
      form.addEventListener('submit', function (e) {
        // Deja pasar el submit del botón de pago rápido (Shop Pay).
        if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
        e.preventDefault();
        var idInput = form.querySelector('[name="id"]');
        if (!idInput || mainBtn.disabled) return;
        var eng = getEngrave();
        var mainItem = { id: parseInt(idInput.value, 10), quantity: 1 };
        if (eng.properties) mainItem.properties = eng.properties;
        // Preventa: propiedad visible (carrito, checkout, pedido y emails)
        // + marca oculta _preventa para el carrito lateral.
        if (mainBtn.hasAttribute('data-preorder')) {
          mainItem.properties = mainItem.properties || {};
          mainItem.properties[mainBtn.getAttribute('data-preorder-label') || 'Preventa'] = mainBtn.getAttribute('data-preorder-value') || '';
          mainItem.properties._preventa = '1';
        }
        var items = [mainItem];
        // Producto de servicio de grabado (+precio), si está enlazado y hay texto.
        // Va marcado (_engrave_svc) y ligado a la joya (_engrave_id) para el carrito.
        if (eng.extraVariant) items.push({ id: eng.extraVariant, quantity: 1, properties: { _engrave_svc: 'yes', _engrave_id: eng.engToken } });
        // Filas "Añade una cadena/pulsera/…" (template look): suma lo elegido.
        root.querySelectorAll('[data-pdp-addon-row][data-selected-variant]').forEach(function (row) {
          items.push({ id: parseInt(row.getAttribute('data-selected-variant'), 10), quantity: 1 });
        });
        // Filas multi: cada tile marcado es una línea más del carrito.
        root.querySelectorAll('[data-pdp-addon-row][data-addon-multi] [data-addon-pick].is-selected:not([data-addon-none])').forEach(function (b) {
          items.push({ id: parseInt(b.getAttribute('data-variant'), 10), quantity: 1 });
        });
        root.querySelectorAll('[data-pdp-addon-grid] [data-grid-pick].is-selected').forEach(function (b) {
          items.push({ id: parseInt(b.getAttribute('data-variant'), 10), quantity: 1 });
        });
        // Vista previa para la línea provisional del sidecart
        var pvImg = root.querySelector('.apodemia-pdp__media.is-active img') || root.querySelector('.apodemia-pdp__img');
        var pvTitle = root.querySelector('.apodemia-pdp__title');
        var pvPrice = root.querySelector('[data-pdp-price]');
        var pvVariant = '';
        try {
          var vj = JSON.parse((root.querySelector('[data-pdp-variants]') || {}).textContent || '[]');
          vj.forEach(function (v) { if (String(v.id) === String(idInput.value) && v.title && v.title !== 'Default Title') pvVariant = v.title; });
        } catch (err) { /* noop */ }
        var previews = [{
          title: pvTitle ? pvTitle.textContent.trim() : '',
          image: pvImg ? (pvImg.currentSrc || pvImg.src) : '',
          price: pvPrice ? pvPrice.textContent.trim() : '',
          variant: pvVariant
        }];
        // Charms / cadenas elegidos: también aparecen al instante
        root.querySelectorAll('[data-pdp-addon-row][data-addon-multi] [data-addon-pick].is-selected:not([data-addon-none]), [data-pdp-addon-row]:not([data-addon-multi]) [data-addon-pick].is-selected:not([data-addon-none])').forEach(function (b) {
          var im = b.querySelector('img');
          previews.push({
            title: b.getAttribute('data-title') || '',
            image: im ? (im.currentSrc || im.src) : '',
            price: formatMoney(parseInt(b.getAttribute('data-price'), 10) || 0)
          });
        });
        mainBtn.disabled = true;
        addToCart(items, previews)
          .catch(function () {})
          .finally(function () {
            mainBtn.disabled = false;
          });
      });
    }

    // ----- Upsells "Combínalo con" -----
    root.querySelectorAll('[data-pdp-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        btn.disabled = true;
        var card = btn.closest('.apodemia-pdp__gift-card, .apodemia-pdp__combine-card');
        var cImg = card && card.querySelector('img');
        var cName = card && card.querySelector('.apodemia-pdp__gift-name, .apodemia-pdp__combine-title');
        var cPrice = card && card.querySelector('.apodemia-pdp__gift-price, .apodemia-pdp__combine-price');
        var cPriceNow = cPrice ? cPrice.cloneNode(true) : null;
        if (cPriceNow) cPriceNow.querySelectorAll('s').forEach(function (x) { x.remove(); });
        addToCart([{ id: parseInt(btn.getAttribute('data-pdp-add'), 10), quantity: 1 }], [{
          title: cName ? cName.textContent.trim() : '',
          image: cImg ? (cImg.currentSrc || cImg.src) : '',
          price: cPriceNow ? cPriceNow.textContent.trim() : ''
        }])
          .catch(function () {})
          .finally(function () {
            btn.disabled = false;
          });
      });
    });

    // ----- Carruseles horizontales con barra de progreso ("Combínalo con") -----
    root.querySelectorAll('[data-pdp-hscroll]').forEach(function (box) {
      var track = box.querySelector('[data-pdp-hscroll-track]');
      var bar = box.querySelector('[data-pdp-hscroll-bar]');
      var thumb = box.querySelector('[data-pdp-hscroll-thumb]');
      if (!track || !bar || !thumb) return;
      var update = function () {
        var max = track.scrollWidth - track.clientWidth;
        if (max <= 1) { bar.hidden = true; return; }
        bar.hidden = false;
        var frac = track.clientWidth / track.scrollWidth;
        thumb.style.width = Math.max(frac * 100, 12) + '%';
        var x = (track.scrollLeft / max) * (bar.clientWidth - thumb.offsetWidth);
        thumb.style.transform = 'translateX(' + x + 'px)';
      };
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      if (window.ResizeObserver) new ResizeObserver(update).observe(track);
      update();
    });

    // ----- Compra rápida en móvil/táctil: 1er toque en la foto muestra la barra -----
    var touchQaMq = window.matchMedia('(max-width: 989px), (hover: none)');
    var qaMedias = root.querySelectorAll('.apodemia-pdp__gift-media, .apodemia-pdp__combine-media');
    var closeQa = function (except) {
      Array.prototype.forEach.call(qaMedias, function (m) { if (m !== except) m.classList.remove('is-qa-open'); });
    };
    Array.prototype.forEach.call(qaMedias, function (media) {
      var link = media.querySelector('a:not(.apodemia-pdp__qa)');
      if (!link || !media.querySelector('.apodemia-pdp__qa')) return;
      link.addEventListener('click', function (e) {
        if (!touchQaMq.matches || media.classList.contains('is-qa-open')) return;
        e.preventDefault();
        closeQa(media);
        media.classList.add('is-qa-open');
      });
    });
    if (qaMedias.length) {
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.apodemia-pdp__gift-media, .apodemia-pdp__combine-media')) closeQa(null);
      });
    }

    // Carruseles de abajo con estilo PDP (fuera de esta sección; los vistos se
    // cargan después): 1er toque en la foto muestra la barra de añadir.
    if (!window.__pdpRowQa) {
      window.__pdpRowQa = true;
      document.addEventListener('click', function (e) {
        var rowLink = e.target.closest('.apodemia-product-row--pdp .apodemia-product-card__media-link');
        var open = document.querySelectorAll('.apodemia-product-row--pdp .apodemia-product-card.is-qa-open');
        if (rowLink && touchQaMq.matches) {
          var card = rowLink.closest('.apodemia-product-card');
          if (card && !card.classList.contains('is-qa-open')) {
            e.preventDefault();
            Array.prototype.forEach.call(open, function (c) { c.classList.remove('is-qa-open'); });
            card.classList.add('is-qa-open');
            return;
          }
        }
        if (!e.target.closest('.apodemia-product-row--pdp .apodemia-product-card')) {
          Array.prototype.forEach.call(open, function (c) { c.classList.remove('is-qa-open'); });
        }
      });
    }

    // ----- Burbujas de ventajas: una sola abierta (teclado y táctil) -----
    var tipItems = root.querySelectorAll('.apodemia-pdp__trust-item.has-info');
    if (tipItems.length) {
      var closeTips = function (except) {
        Array.prototype.forEach.call(tipItems, function (t) { if (t !== except) t.classList.remove('is-tip-open'); });
      };
      Array.prototype.forEach.call(tipItems, function (item) {
        item.addEventListener('click', function () {
          if (!touchQaMq.matches) return; // con ratón basta el hover
          var open = !item.classList.contains('is-tip-open');
          closeTips(item);
          item.classList.toggle('is-tip-open', open);
        });
        item.addEventListener('keyup', function (e) {
          if (e.key === 'Tab') { closeTips(item); item.classList.add('is-tip-open'); }
        });
        item.addEventListener('blur', function () { item.classList.remove('is-tip-open'); });
        item.addEventListener('mouseenter', function () { closeTips(null); });
      });
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.apodemia-pdp__trust-item')) closeTips(null);
      });
    }

    // ----- Pestañas (Descripción – Detalles – …) -----
    root.querySelectorAll('[data-pdp-tabs]').forEach(function (group) {
      var tabs = Array.prototype.slice.call(group.querySelectorAll('[data-pdp-tab]'));
      var nav = group.querySelector('[role="tablist"]');
      // Degradados según haya contenido oculto a cada lado
      var updateFades = function () {
        if (!nav) return;
        var max = nav.scrollWidth - nav.clientWidth;
        nav.classList.toggle('is-fade-left', nav.scrollLeft > 2);
        nav.classList.toggle('is-fade-right', max - nav.scrollLeft > 2);
      };
      // Arrastre con ratón (en táctil ya desliza de forma nativa)
      var dragMoved = false;
      if (nav) {
        var startX = 0, startScroll = 0, dragging = false;
        nav.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse' || nav.scrollWidth <= nav.clientWidth) return;
          dragging = true; dragMoved = false;
          startX = e.clientX; startScroll = nav.scrollLeft;
        });
        window.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          var dx = e.clientX - startX;
          if (Math.abs(dx) > 4) { dragMoved = true; nav.classList.add('is-dragging'); }
          nav.scrollLeft = startScroll - dx;
        });
        window.addEventListener('pointerup', function () {
          if (!dragging) return;
          dragging = false;
          nav.classList.remove('is-dragging');
        });
        nav.addEventListener('scroll', updateFades, { passive: true });
        window.addEventListener('resize', updateFades);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(updateFades);
        updateFades();
      }
      var collapsible = group.hasAttribute('data-pdp-tabs-collapsible');
      var select = function (tab, focus) {
        // Plegables: un clic en la pestaña abierta la cierra
        if (collapsible && tab && tab.getAttribute('aria-selected') === 'true') tab = null;
        tabs.forEach(function (t) {
          var on = t === tab;
          if (collapsible) t.setAttribute('aria-expanded', on ? 'true' : 'false');
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus && tab) tab.focus();
        // Deja la pestaña elegida a la vista dentro de la fila
        if (tab && nav && nav.scrollWidth > nav.clientWidth) {
          var l = tab.offsetLeft - nav.offsetLeft;
          if (l < nav.scrollLeft || l + tab.offsetWidth > nav.scrollLeft + nav.clientWidth) {
            nav.scrollTo({ left: Math.max(0, l - 24), behavior: 'smooth' });
          }
        }
        root.dispatchEvent(new CustomEvent('pdp:tab-change'));
      };
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function (e) {
          if (dragMoved) { dragMoved = false; e.preventDefault(); return; }
          select(t);
        });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          else if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') n = tabs[0];
          else if (e.key === 'End') n = tabs[tabs.length - 1];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
    });

    // ----- Cambio de variante (select, pills u opciones) -----
    var select = root.querySelector('[data-pdp-variant]');
    var pills = root.querySelectorAll('[data-pdp-pill]');
    var optPicks = root.querySelectorAll('[data-pdp-opt-pick]');
    var dataEl = root.querySelector('[data-pdp-variants]');
    if (dataEl && (select || pills.length || optPicks.length)) {
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { /* noop */ }
      var priceEl = root.querySelector('[data-pdp-price]');
      var compareEl = root.querySelector('[data-pdp-compare]');
      var instEls = root.querySelectorAll('[data-pdp-installment]');
      var stockEl = root.querySelector('[data-pdp-stock]');
      var stockText = root.querySelector('[data-pdp-stock-text]');

      // Recalculo exacto de la fecha de entrega en el cliente (el SSR llega
      // cacheado por el CDN y la hora de corte necesita la hora real).
      // Reglas: antes del corte se expide ese laborable, despues el siguiente;
      // entrega = 1-2 laborables tras expedir; expedicion en viernes = solo lunes.
      if (stockText && stockText.getAttribute('data-fmt-on')) {
        try {
          var parts = new Intl.DateTimeFormat('en-GB', {
            timeZone: 'Europe/Madrid', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23'
          }).formatToParts(new Date()).reduce(function (o, p) { o[p.type] = p.value; return o; }, {});
          var cutoff = parseInt(stockText.getAttribute('data-cutoff') || '14', 10);
          var wdFull = (stockText.getAttribute('data-weekdays-full') || '').split(',');
          var monthsNames = (stockText.getAttribute('data-months') || '').split(',');
          // Contador de dias sin hora (UTC puro para evitar DST)
          var day = Date.UTC(+parts.year, +parts.month - 1, +parts.day);
          var DAY = 86400000;
          var dowOf = function (ts) { return (new Date(ts).getUTCDay() + 6) % 7; }; // 0=lunes ... 6=domingo
          // Festivos (no se expide ni se entrega): nacionales fijos, Viernes Santo y los
          // «Días sin envío» del bloque (data-holidays, AAAA-MM-DD). Misma regla en el Liquid.
          var pad = function (n) { return (n < 10 ? '0' : '') + n; };
          var extraHol = (stockText.getAttribute('data-holidays') || '').split(/[\s,]+/);
          var goodFriday = function (y) {
            var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
              f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
              i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7,
              m = Math.floor((a + 11 * h + 22 * l) / 451), n = h + l - 7 * m + 114;
            return Date.UTC(y, Math.floor(n / 31) - 1, (n % 31) + 1) - 2 * DAY;
          };
          // Calendario BOE: fiestas nacionales fijas; Jueves Santo (todas las CCAA salvo
          // Cataluña y C. Valenciana) y Viernes Santo; y el lunes siguiente cuando una fiesta
          // nacional cae en domingo (lo trasladan casi todas las CCAA: 2-nov y 7-dic en 2026).
          var NATIONAL = ',01-01,01-06,05-01,08-15,10-12,11-01,12-06,12-08,12-25,';
          var mdOf = function (ts) { var dt = new Date(ts); return pad(dt.getUTCMonth() + 1) + '-' + pad(dt.getUTCDate()); };
          var isHoliday = function (ts) {
            var dt = new Date(ts), y = dt.getUTCFullYear(), md = mdOf(ts), gf = goodFriday(y);
            if (NATIONAL.indexOf(',' + md + ',') !== -1) return true;
            if (ts === gf || ts === gf - DAY) return true;
            if (dowOf(ts) === 0 && NATIONAL.indexOf(',' + mdOf(ts - DAY) + ',') !== -1) return true;
            return extraHol.indexOf(y + '-' + md) !== -1;
          };
          var isWork = function (ts) { return dowOf(ts) <= 4 && !isHoliday(ts); };
          if (+parts.hour >= cutoff) day += DAY;
          while (!isWork(day)) day += DAY; // dia de expedicion laborable
          var dispatchDow = dowOf(day);
          day += DAY;
          while (!isWork(day)) day += DAY; // primer dia de entrega
          var from = new Date(day);
          var fecha;
          var fmt = function (tpl, map) {
            return tpl.replace(/\[(\w+)\]/g, function (_, k) { return map[k] != null ? map[k] : ''; });
          };
          if (dispatchDow === 4) {
            // Expedido en viernes: entrega solo lunes
            fecha = fmt(stockText.getAttribute('data-fmt-on'), {
              wd: wdFull[dowOf(day)], day: from.getUTCDate(), month: monthsNames[from.getUTCMonth()]
            });
          } else {
            var day2 = day + DAY;
            while (!isWork(day2)) day2 += DAY;
            var to = new Date(day2);
            if (from.getUTCMonth() === to.getUTCMonth()) {
              fecha = fmt(stockText.getAttribute('data-fmt-same'), {
                from_wd: wdFull[dowOf(day)], from: from.getUTCDate(),
                to_wd: wdFull[dowOf(day2)], to: to.getUTCDate(), month: monthsNames[to.getUTCMonth()]
              });
            } else {
              fecha = fmt(stockText.getAttribute('data-fmt-cross'), {
                from_wd: wdFull[dowOf(day)], from: from.getUTCDate(), month_from: monthsNames[from.getUTCMonth()],
                to_wd: wdFull[dowOf(day2)], to: to.getUTCDate(), month_to: monthsNames[to.getUTCMonth()]
              });
            }
          }
          if (fecha) {
            stockText.setAttribute('data-fecha', fecha);
            var m = (stockEl && stockEl.className.match(/apodemia-pdp__stock--(in|low|out|pre)/)) || null;
            var tpl0 = stockText.getAttribute('data-text-' + (m ? m[1] : 'in')) || '';
            if (tpl0.indexOf('[fecha]') !== -1) stockText.textContent = tpl0.replace('[fecha]', fecha);
          }
        } catch (e) { /* fallback: se queda la fecha SSR */ }
      }

      var findVariant = function (id) {
        return variants.find(function (x) { return String(x.id) === String(id); });
      };

      var applyVariant = function (v) {
        if (!v) return;
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (compareEl) {
          if (v.compare > v.price) {
            compareEl.textContent = formatMoney(v.compare);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        Array.prototype.forEach.call(instEls, function (instEl) {
          var months = parseInt(instEl.getAttribute('data-months') || '3', 10);
          instEl.textContent = formatMoney(Math.floor(v.price / months));
        });
        // Precio dinámico del botón (si está activo)
        addBasePrice = v.price;
        updateAddPrice();
        // Preventa: producto marcado y variante disponible (tenga o no stock).
        var preEnabled = !!(mainBtn && mainBtn.hasAttribute('data-preorder-enabled'));
        var isPre = preEnabled && !!v.available;
        v.preorder = isPre;
        if (mainBtn) {
          mainBtn.disabled = !v.available;
          // En preventa sin poder comprarse: botón desactivado "Próximamente".
          mainBtn.hidden = !v.available && !preEnabled;
          mainBtn.toggleAttribute('data-preorder', isPre);
          var addLabel = mainBtn.querySelector('[data-pdp-add-label]');
          var labelAttr = !v.available ? (preEnabled ? 'data-label-soon' : '') : (isPre ? 'data-label-pre' : 'data-label-add');
          if (addLabel && labelAttr) addLabel.textContent = mainBtn.getAttribute(labelAttr) || addLabel.textContent;
        }
        // Avísame (sin stock / preventa): visible solo si la variante no está disponible.
        var notifyBox = root.querySelector('[data-pdp-notify]');
        if (notifyBox) {
          notifyBox.hidden = !!v.available;
          if (String(notifyBox.getAttribute('data-variant')) !== String(v.id)) {
            notifyBox.setAttribute('data-variant', v.id);
            var nForm = notifyBox.querySelector('[data-pdp-notify-form]');
            var nOk = notifyBox.querySelector('[data-pdp-notify-success]');
            if (nForm) nForm.hidden = false;
            if (nOk) nOk.hidden = true;
          }
        }
        if (stockEl && stockText) {
          var threshold = parseInt(stockEl.getAttribute('data-threshold') || '10', 10);
          var state = 'in';
          if (!v.available) state = 'out';
          else if (isPre) state = 'pre';
          else if (v.managed && v.qty > 0 && v.qty <= threshold) state = 'low';
          stockEl.classList.remove('apodemia-pdp__stock--in', 'apodemia-pdp__stock--low', 'apodemia-pdp__stock--out', 'apodemia-pdp__stock--pre');
          stockEl.classList.add('apodemia-pdp__stock--' + state);
          var tpl = stockText.getAttribute('data-text-' + state) || '';
          stockText.textContent = tpl.replace('[fecha]', stockText.getAttribute('data-fecha') || '');
        }
        // Notifica al sticky add-to-cart (precio / ahorro / anuncio).
        document.dispatchEvent(new CustomEvent('pdp:variant', { detail: v }));
      };

      if (select) {
        select.addEventListener('change', function () {
          // Si el selector vive fuera del form (bloque independiente), volcar
          // la selección al input name=id del form.
          var formInput = root.querySelector('form[action*="/cart/add"] [name="id"]');
          if (formInput && formInput !== select) formInput.value = select.value;
          applyVariant(findVariant(select.value));
        });
      }

      // Selector por opciones (template anillos: Piedra swatches + Talla pills)
      if (optPicks.length) {
        var optInput = root.querySelector('[data-pdp-variant-input]');
        var current = optInput ? findVariant(optInput.value) : null;
        var selectedOpts = current && current.options ? current.options.slice() : [];

        // Marca como agotadas (is-soldout) las opciones que, con el resto de
        // opciones elegidas, no tienen variante disponible (tallas tachadas).
        var markSoldOut = function () {
          optPicks.forEach(function (o) {
            var oi2 = parseInt(o.getAttribute('data-opt'), 10);
            var val = o.getAttribute('data-value');
            var ok = variants.some(function (x) {
              if (!x.options || !x.available) return false;
              for (var i = 0; i < selectedOpts.length; i++) {
                var want = i === oi2 ? val : selectedOpts[i];
                if (String(x.options[i]) !== String(want)) return false;
              }
              return true;
            });
            o.classList.toggle('is-soldout', !ok);
          });
        };
        markSoldOut();

        optPicks.forEach(function (p) {
          p.addEventListener('click', function () {
            var oi = parseInt(p.getAttribute('data-opt'), 10);
            var value = p.getAttribute('data-value');
            if (p.classList.contains('is-selected')) return;
            // Marca visual dentro del mismo grupo de opción
            optPicks.forEach(function (o) {
              if (parseInt(o.getAttribute('data-opt'), 10) === oi) {
                o.classList.remove('is-selected');
                o.setAttribute('aria-pressed', 'false');
              }
            });
            p.classList.add('is-selected');
            p.setAttribute('aria-pressed', 'true');
            var valEl = root.querySelector('[data-pdp-opt-value="' + oi + '"]');
            if (valEl) valEl.textContent = value;
            selectedOpts[oi] = value;
            markSoldOut();
            // Resuelve la variante que combina TODAS las opciones elegidas
            var v = variants.find(function (x) {
              if (!x.options) return false;
              for (var i = 0; i < selectedOpts.length; i++) {
                if (String(x.options[i]) !== String(selectedOpts[i])) return false;
              }
              return true;
            });
            if (v) {
              if (optInput) optInput.value = v.id;
              applyVariant(v);
            } else if (mainBtn) {
              // Combinación inexistente → no se puede comprar
              mainBtn.disabled = true;
            }
          });
        });
      }

      // Pills (template pendientes: Pareja | Unidad)
      if (pills.length) {
        var pillInput = root.querySelector('[data-pdp-variant-input]');
        var pillValue = root.querySelector('[data-pdp-variant-value]');
        pills.forEach(function (p) {
          p.addEventListener('click', function () {
            if (p.disabled || p.classList.contains('is-selected')) return;
            pills.forEach(function (o) {
              o.classList.remove('is-selected');
              o.setAttribute('aria-pressed', 'false');
            });
            p.classList.add('is-selected');
            p.setAttribute('aria-pressed', 'true');
            if (pillInput) pillInput.value = p.getAttribute('data-variant');
            if (pillValue) pillValue.textContent = p.getAttribute('data-title');
            applyVariant(findVariant(p.getAttribute('data-variant')));
          });
        });
      }
    }

    // ----- Guía de tallas (modal) -----
    var sgModal = root.querySelector('[data-pdp-sizeguide]');
    if (sgModal) {
      root.querySelectorAll('[data-pdp-sizeguide-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          // Resalta en la tabla la talla elegida ahora mismo
          var sel = root.querySelector('.apodemia-pdp__opt-values--sizes .is-selected');
          var cur = sel ? (sel.getAttribute('data-value') || sel.textContent).trim() : '';
          sgModal.querySelectorAll('tbody tr').forEach(function (tr) {
            var first = tr.querySelector('td');
            tr.classList.toggle('is-current', !!cur && !!first && first.textContent.trim() === cur);
          });
          sgModal.hidden = false;
        });
      });
      sgModal.querySelectorAll('[data-pdp-sizeguide-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          sgModal.hidden = true;
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !sgModal.hidden) sgModal.hidden = true;
      });
    }

    // ----- Precio dinámico del botón (base + joyas elegidas) -----
    var addPriceEl = root.querySelector('[data-pdp-add-price]');
    var addBasePrice = addPriceEl ? parseInt(addPriceEl.getAttribute('data-base'), 10) || 0 : 0;
    var updateAddPrice = function () {
      if (!addPriceEl) return;
      var total = addBasePrice;
      root.querySelectorAll('[data-pdp-addon-row][data-selected-variant]').forEach(function (row) {
        total += parseInt(row.getAttribute('data-selected-price'), 10) || 0;
      });
      // Filas multi: suma cada tile marcado (estas filas no llevan data-selected-variant).
      root.querySelectorAll('[data-pdp-addon-row][data-addon-multi] [data-addon-pick].is-selected:not([data-addon-none])').forEach(function (b) {
        total += parseInt(b.getAttribute('data-price'), 10) || 0;
      });
      root.querySelectorAll('[data-pdp-addon-grid] [data-grid-pick].is-selected').forEach(function (b) {
        total += parseInt(b.getAttribute('data-price'), 10) || 0;
      });
      addPriceEl.textContent = formatMoney(total);
    };

    // ----- Pestañas de categoría de charms ("crea tu joya"): filtran los thumbs
    // por data-addon-cat. Oculta las pestañas sin charms y activa la primera con
    // contenido. La selección multi persiste al cambiar de pestaña. -----
    // Como la página "Crea tu joya": cada categoría es un desplegable (+) con su
    // cuadrícula de charms; la primera con contenido abierta. "Ninguno" pasa a
    // la cabecera. La selección múltiple no cambia (mismos botones).
    root.querySelectorAll('[data-pdp-addon-row][data-addon-cats]').forEach(function (row) {
      var tabs = Array.prototype.slice.call(row.querySelectorAll('[data-addon-cat-tab]'));
      var thumbs = Array.prototype.slice.call(row.querySelectorAll('[data-addon-cat]'));
      var strip = row.querySelector('.apodemia-pdp__addon-strip');
      if (!tabs.length || !thumbs.length || !strip) return;
      var noneBtn = row.querySelector('[data-addon-none]');
      var head = row.querySelector('.apodemia-pdp__addon-head');
      if (noneBtn && head) {
        noneBtn.classList.add('apodemia-pdp__addon-item--inline');
        head.appendChild(noneBtn);
      }
      var acc = document.createElement('div');
      acc.className = 'apodemia-pdp__acc';
      var first = true;
      tabs.forEach(function (t) {
        var cat = t.getAttribute('data-addon-cat-tab');
        var items = thumbs.filter(function (b) { return b.getAttribute('data-addon-cat') === cat; });
        if (!items.length) return;
        var wrap = document.createElement('div');
        wrap.className = 'apodemia-pdp__acc-cat';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'apodemia-pdp__acc-head';
        btn.setAttribute('aria-expanded', first ? 'true' : 'false');
        btn.innerHTML = '<span></span><span class="apodemia-pdp__acc-icon" aria-hidden="true"></span>';
        btn.firstChild.textContent = t.textContent.trim();
        var body = document.createElement('div');
        body.className = 'apodemia-pdp__acc-body';
        body.hidden = !first;
        items.forEach(function (b) { b.hidden = false; body.appendChild(b); });
        btn.addEventListener('click', function () {
          var open = btn.getAttribute('aria-expanded') !== 'true';
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          body.hidden = !open;
        });
        wrap.appendChild(btn);
        wrap.appendChild(body);
        acc.appendChild(wrap);
        first = false;
      });
      strip.parentNode.insertBefore(acc, strip);
      strip.hidden = true;
      var tabBar = row.querySelector('.apodemia-pdp__addon-cats');
      if (tabBar) tabBar.hidden = true;
      row.classList.add('is-acc-ready');
    });

    // ----- "Ver más" de los selectores de joyas: despliega los thumbs ocultos
    // hacia abajo (la fila pasa a rejilla envuelta; CSS .is-expanded). -----
    root.querySelectorAll('[data-addon-expand]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var addon = btn.closest('.apodemia-pdp__addon');
        var strip = addon && addon.querySelector('.apodemia-pdp__addon-strip');
        if (!strip) return;
        var open = strip.classList.toggle('is-expanded');
        strip.querySelectorAll('[data-addon-extra]').forEach(function (t) { t.hidden = !open; });
        btn.textContent = btn.getAttribute(open ? 'data-less' : 'data-more');
      });
    });

    // ----- Filas "Añade una cadena/pulsera/…" (template look) -----
    root.querySelectorAll('[data-pdp-addon-row]').forEach(function (row) {
      var nameEl = row.querySelector('[data-addon-name]');
      var priceEl = row.querySelector('[data-addon-price]');
      var items = row.querySelectorAll('[data-addon-pick]');

      // CRO: el badge conserva el "10% OFF"; junto a él, en un elemento aparte
      // ([data-addon-save]), se muestra el ahorro EN € del charm elegido. El %
      // se lee una vez del texto del badge. Sin selección, teaser con el primer
      // charm. Ambos los oculta el ajuste show_pack_discounts (Liquid), así que
      // si no existe el badge no hay nada que calcular.
      var badgeEl = row.querySelector('.apodemia-pdp__bundle-badge');
      var saveEl = row.querySelector('[data-addon-save]');
      var savePct = 0;
      if (badgeEl) {
        var pctMatch = (badgeEl.textContent || '').match(/(\d+(?:[.,]\d+)?)\s*%/);
        if (pctMatch) savePct = parseFloat(pctMatch[1].replace(',', '.'));
      }
      var firstCharm = row.querySelector('[data-addon-pick]:not([data-addon-none])');
      var teaserPrice = firstCharm ? (parseInt(firstCharm.getAttribute('data-price'), 10) || 0) : 0;
      var showSave = function (cents) {
        if (!saveEl || savePct <= 0) return;
        var base = cents > 0 ? cents : teaserPrice;
        var save = base > 0 ? Math.round(base * savePct / 100) : 0;
        if (save > 0) {
          saveEl.textContent = (saveEl.getAttribute('data-t-save') || 'Ahorras') + ' ' + formatMoney(save);
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      };

      var select = function (btn) {
        items.forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        if (btn && btn.hasAttribute('data-addon-none')) {
          // "Sin charm": queda visualmente marcado, pero NO añade nada al carrito.
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
          row.removeAttribute('data-selected-variant');
          row.removeAttribute('data-selected-price');
          if (nameEl) nameEl.hidden = true;
          if (priceEl) priceEl.hidden = true;
          showSave(0);
          updateAddPrice();
          return;
        }
        if (btn) {
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
          row.setAttribute('data-selected-variant', btn.getAttribute('data-variant'));
          row.setAttribute('data-selected-price', btn.getAttribute('data-price'));
          if (nameEl) {
            nameEl.textContent = btn.getAttribute('data-title');
            nameEl.hidden = false;
          }
          if (priceEl) {
            priceEl.textContent = '+' + formatMoney(parseInt(btn.getAttribute('data-price'), 10));
            priceEl.hidden = false;
          }
          showSave(parseInt(btn.getAttribute('data-price'), 10) || 0);
        } else {
          row.removeAttribute('data-selected-variant');
          row.removeAttribute('data-selected-price');
          if (nameEl) nameEl.hidden = true;
          if (priceEl) priceEl.hidden = true;
          showSave(0);
        }
        updateAddPrice();
      };

      var noneBtn = row.querySelector('[data-addon-none]');

      // ----- Fila MULTI (data-addon-multi): cada tile alterna; se pueden
      // llevar varios (p. ej. varios charms). "Ninguno" limpia todo y queda
      // marcado cuando no hay nada elegido. El carrito y el precio del botón
      // suman todas las marcadas (ver submit y updateAddPrice).
      if (row.hasAttribute('data-addon-multi')) {
        // Resumen claro: sin selección, aviso "Puedes elegir uno o varios";
        // con selección, lista (nombre, precio, quitar), total, ahorro y
        // "Quitar todos". "Ninguno" deja de verse (lo sustituye "Quitar todos").
        var summary = row.querySelector('[data-addon-summary]');
        var sumList = row.querySelector('[data-addon-summary-list]');
        var sumTotal = row.querySelector('[data-addon-total]');
        var hint = row.querySelector('[data-addon-hint]');
        var clearBtn = row.querySelector('[data-addon-clear]');
        var saveSlot = row.querySelector('[data-addon-save-slot]');
        if (summary) {
          if (noneBtn) noneBtn.hidden = true;
          // "Ahorras" en su propia línea bajo el total (no pegado al precio)
          if (saveEl) {
            var saveLine = document.createElement('div');
            saveLine.className = 'apodemia-pdp__addon-summary-save';
            saveLine.appendChild(saveEl);
            summary.appendChild(saveLine);
          }
        }
        var syncMulti = function () {
          var sel = Array.prototype.slice.call(row.querySelectorAll('[data-addon-pick].is-selected:not([data-addon-none])'));
          if (noneBtn) {
            var noneOn = sel.length === 0;
            noneBtn.classList.toggle('is-selected', noneOn);
            noneBtn.setAttribute('aria-pressed', noneOn ? 'true' : 'false');
          }
          var sum = 0;
          var names = sel.map(function (b) {
            sum += parseInt(b.getAttribute('data-price'), 10) || 0;
            return b.getAttribute('data-title');
          });
          if (summary) {
            if (nameEl) nameEl.hidden = true;
            if (priceEl) priceEl.hidden = true;
            sumList.innerHTML = '';
            sel.forEach(function (b) {
              var li = document.createElement('li');
              li.className = 'apodemia-pdp__addon-summary-item';
              li.innerHTML = '<span class="apodemia-pdp__addon-summary-name"></span><span class="apodemia-pdp__addon-summary-price"></span><button type="button" class="apodemia-pdp__addon-summary-remove"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M1.5 1.5l7 7M8.5 1.5l-7 7" stroke="currentColor" stroke-width="1.1" stroke-linecap="round"/></svg></button>';
              li.children[0].textContent = b.getAttribute('data-title');
              li.children[1].textContent = formatMoney(parseInt(b.getAttribute('data-price'), 10) || 0);
              var rm = li.children[2];
              rm.setAttribute('aria-label', (summary.getAttribute('data-t-remove') || '') + ' ' + b.getAttribute('data-title'));
              rm.addEventListener('click', function () {
                b.classList.remove('is-selected');
                b.setAttribute('aria-pressed', 'false');
                syncMulti();
              });
              sumList.appendChild(li);
            });
            if (sumTotal) {
              // Con descuento: total original tachado + total con descuento
              var saveCents = (saveEl && savePct > 0) ? Math.round(sum * savePct / 100) : 0;
              if (saveCents > 0) {
                sumTotal.innerHTML = '<s class="apodemia-pdp__addon-summary-was"></s><span></span>';
                sumTotal.children[0].textContent = formatMoney(sum);
                sumTotal.children[1].textContent = '+' + formatMoney(sum - saveCents);
              } else {
                sumTotal.textContent = '+' + formatMoney(sum);
              }
            }
            summary.hidden = sel.length === 0;
            if (hint) hint.hidden = sel.length > 0;
            if (sel.length) showSave(sum);
            else if (saveEl) saveEl.hidden = true;
            updateAddPrice();
            return;
          }
          if (nameEl) {
            nameEl.textContent = names.join(' + ');
            nameEl.hidden = names.length === 0;
          }
          if (priceEl) {
            priceEl.textContent = '+' + formatMoney(sum);
            priceEl.hidden = sum === 0;
          }
          showSave(sum);
          updateAddPrice();
        };
        if (clearBtn) {
          clearBtn.addEventListener('click', function () {
            row.querySelectorAll('[data-addon-pick].is-selected').forEach(function (x) {
              x.classList.remove('is-selected');
              x.setAttribute('aria-pressed', 'false');
            });
            syncMulti();
          });
        }
        items.forEach(function (b) {
          b.addEventListener('click', function () {
            if (b === noneBtn) {
              row.querySelectorAll('[data-addon-pick].is-selected').forEach(function (x) {
                x.classList.remove('is-selected');
                x.setAttribute('aria-pressed', 'false');
              });
            } else {
              var on = b.classList.toggle('is-selected');
              b.setAttribute('aria-pressed', on ? 'true' : 'false');
            }
            syncMulti();
          });
        });
        syncMulti(); // estado inicial ("Ninguno" marcado si existe)
        return;
      }

      items.forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.classList.contains('is-selected')) {
            // Desmarcar la seleccionada: si la fila tiene "Ninguno", vuelve a él
            // (dupla addon/Ninguno); "Ninguno" ya marcado se queda como está.
            if (b === noneBtn) return;
            select(noneBtn || null);
          } else {
            select(b);
          }
        });
      });

      // Al entrar: "Ninguno" marcado por defecto si existe (y el badge muestra
      // el ahorro en € del primer charm como reclamo). Sin preselección, igual
      // pintamos el reclamo para que el badge nunca se quede en "10% OFF".
      if (row.hasAttribute('data-addon-preselect') && items.length) select(noneBtn || items[0]);
      else showSave(0);
    });

    // ----- Grid "Añade más charms" (multi-selección, template look) -----
    root.querySelectorAll('[data-pdp-addon-grid] [data-grid-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        var sel = b.classList.toggle('is-selected');
        b.setAttribute('aria-pressed', sel ? 'true' : 'false');
        updateAddPrice();
      });
    });

    // ----- "Completa tu compra" (bundle) -----
    var bundle = root.querySelector('[data-pdp-bundle]');
    if (bundle) {
      var bData = { base: null, candidates: [], remove_label: 'Quitar' };
      try { bData = JSON.parse(bundle.querySelector('[data-bundle-data]').textContent); } catch (e) { /* noop */ }
      // Dedup por id
      var seen = {};
      bData.candidates = (bData.candidates || []).filter(function (c) {
        if (!c || !c.variant || seen[c.id]) return false;
        seen[c.id] = true;
        return true;
      });

      var picker = bundle.querySelector('[data-bundle-picker]');
      var list = bundle.querySelector('[data-bundle-list]');
      var addBtn = bundle.querySelector('[data-bundle-add]');
      var slots = { 1: null, 2: null }; // slot → candidate
      var defaults = {
        1: bundle.querySelector('[data-bundle-label="1"]') ? bundle.querySelector('[data-bundle-label="1"]').textContent : '',
        2: bundle.querySelector('[data-bundle-label="2"]') ? bundle.querySelector('[data-bundle-label="2"]').textContent : '',
      };
      var activeSlot = null;

      var renderSlot = function (n) {
        var btn = bundle.querySelector('[data-bundle-open="' + n + '"]');
        var label = bundle.querySelector('[data-bundle-label="' + n + '"]');
        var c = slots[n];
        if (c) {
          btn.innerHTML = c.image
            ? '<img class="apodemia-pdp__bundle-img" src="' + c.image + '" alt="">'
            : '<span class="apodemia-pdp__bundle-plus" aria-hidden="true"></span>';
          if (label) label.textContent = c.title;
        } else {
          btn.innerHTML = '<span class="apodemia-pdp__bundle-plus" aria-hidden="true"></span>';
          if (label) label.textContent = defaults[n];
        }
      };

      var updateAdd = function () {
        var count = (slots[1] ? 1 : 0) + (slots[2] ? 1 : 0);
        addBtn.hidden = count === 0;
        addBtn.textContent = addBtn.getAttribute(count >= 2 ? 'data-label-2' : 'data-label-1');
      };

      var closePicker = function () {
        picker.hidden = true;
        activeSlot = null;
      };

      var openPicker = function (n) {
        activeSlot = n;
        list.innerHTML = '';
        // Opción "quitar" si el slot ya tiene joya
        if (slots[n]) {
          var rm = document.createElement('li');
          rm.innerHTML = '<button type="button" class="apodemia-pdp__bundle-item apodemia-pdp__bundle-item--remove"><span class="apodemia-pdp__bundle-item-title">' + bData.remove_label + '</span></button>';
          rm.firstChild.addEventListener('click', function () {
            slots[n] = null;
            renderSlot(n);
            updateAdd();
            closePicker();
          });
          list.appendChild(rm);
        }
        var otherId = slots[n === 1 ? 2 : 1] ? slots[n === 1 ? 2 : 1].id : null;
        bData.candidates.forEach(function (c) {
          if (otherId && c.id === otherId) return; // no repetir la misma joya
          var li = document.createElement('li');
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'apodemia-pdp__bundle-item';
          b.innerHTML = (c.image ? '<img src="' + c.image + '" alt="" loading="lazy">' : '') +
            '<span class="apodemia-pdp__bundle-item-title"></span>' +
            '<span class="apodemia-pdp__bundle-item-price">' + formatMoney(c.price) + '</span>';
          b.querySelector('.apodemia-pdp__bundle-item-title').textContent = c.title;
          b.addEventListener('click', function () {
            slots[n] = c;
            renderSlot(n);
            updateAdd();
            closePicker();
          });
          li.appendChild(b);
          list.appendChild(li);
        });
        picker.hidden = false;
      };

      bundle.querySelectorAll('[data-bundle-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var n = parseInt(btn.getAttribute('data-bundle-open'), 10);
          if (activeSlot === n && !picker.hidden) {
            closePicker();
          } else {
            openPicker(n);
          }
        });
      });
      var closeBtn = bundle.querySelector('[data-bundle-close]');
      if (closeBtn) closeBtn.addEventListener('click', closePicker);

      addBtn.addEventListener('click', function () {
        var idInput = root.querySelector('form[action*="/cart/add"] [name="id"]');
        var items = [];
        if (idInput) items.push({ id: parseInt(idInput.value, 10), quantity: 1 });
        [1, 2].forEach(function (n) {
          if (slots[n]) items.push({ id: slots[n].variant, quantity: 1 });
        });
        if (!items.length) return;
        addBtn.disabled = true;
        addToCart(items)
          .catch(function () {})
          .finally(function () {
            addBtn.disabled = false;
          });
      });
    }

    // ----- "Háztelo gratis en tienda" — modal con el widget nativo de
    // Cowlendar (iframe a su página de reserva). El iframe se carga la 1ª vez
    // que se abre el modal (no en cada PDP). Cowlendar muestra solo las tiendas
    // de la app y registra la cita real.
    var svc = root.querySelector('[data-pdp-storesvc]');
    if (svc) {
      var svcModal = svc.querySelector('[data-storesvc-modal]');
      var svcLoading = svc.querySelector('[data-storesvc-loading]');
      var svcWidget = svc.querySelector('.cowlendar-section');

      var svcOpen = function () {
        svcModal.hidden = false;
        document.body.classList.add('apodemia-storesvc-open');
        // Cowlendar hidrata el div al cargar la pagina; ocultamos el "Cargando"
        // cuando ya ha inyectado contenido.
        if (svcLoading) {
          if (svcWidget && svcWidget.childElementCount > 0) svcLoading.hidden = true;
          else {
            var tries = 0;
            var iv = setInterval(function () {
              tries++;
              if (svcWidget && svcWidget.childElementCount > 0) { svcLoading.hidden = true; clearInterval(iv); }
              if (tries > 40) clearInterval(iv); // ~8s
            }, 200);
          }
        }
      };
      var svcClose = function () {
        svcModal.hidden = true;
        document.body.classList.remove('apodemia-storesvc-open');
      };

      svc.querySelectorAll('[data-storesvc-open]').forEach(function (b) {
        b.addEventListener('click', svcOpen);
      });
      svc.querySelectorAll('[data-storesvc-close]').forEach(function (b) {
        b.addEventListener('click', svcClose);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !svcModal.hidden) svcClose();
      });
    }

    // Móvil: título y precio van DEBAJO de la galería (diseño Sezane), en su
    // orden natural dentro de la columna derecha; ya no se recolocan.
    var gal = root.querySelector('[data-pdp-gallery]');

    // ----- Alto de la galería = alto visible -----
    // La foto principal debe verse ENTERA en cualquier pantalla: se mide dónde
    // empieza la galería (cabecera + migas + espaciado) y el CSS usa
    // 100svh - ese valor - margen inferior para limitar su tamaño.
    var galWrapEl = root.querySelector('[data-pdp-gallery-wrap]');
    if (galWrapEl) {
      var GAL_BOTTOM_GAP = 40;
      var setGalleryOffset = function () {
        var top = galWrapEl.getBoundingClientRect().top + window.scrollY;
        root.style.setProperty('--pdp-gallery-offset', Math.round(top + GAL_BOTTOM_GAP) + 'px');
      };
      setGalleryOffset();
      window.addEventListener('resize', setGalleryOffset);

      // Móvil: foto + título + precio visibles al cargar en cualquier móvil.
      // Alto disponible = alto de pantalla - inicio de la galería - lo que
      // ocupan título y precio bajo ella. Nunca más alto que la proporción
      // natural ni más bajo que el 75 % del ancho. Solo se recalcula al
      // cambiar el ancho (la barra de Safari cambia el alto al hacer scroll).
      var mobileMq = window.matchMedia('(max-width: 989px)');
      var priceRowEl = root.querySelector('.apodemia-pdp__price-row');
      var galEl = galWrapEl.querySelector('[data-pdp-gallery]');
      var lastW = 0;
      var setMobileGallery = function (force) {
        if (!galEl) return;
        if (!mobileMq.matches) {
          root.classList.remove('has-m-gal-h');
          root.style.removeProperty('--pdp-m-gal-h');
          return;
        }
        var w = galEl.clientWidth;
        if (!force && w === lastW) return;
        lastW = w;
        var natural = w * 575 / 473;
        var galTop = galEl.getBoundingClientRect().top + window.scrollY;
        var galBottomNow = galEl.getBoundingClientRect().bottom;
        var titleEl = root.querySelector('.apodemia-pdp__title');
        var infoBottom = Math.max(
          priceRowEl ? priceRowEl.getBoundingClientRect().bottom : 0,
          titleEl ? titleEl.getBoundingClientRect().bottom : 0
        );
        var infoH = infoBottom ? Math.max(0, infoBottom - galBottomNow) : 90;
        var avail = window.innerHeight - galTop - infoH - 16;
        var h = Math.round(Math.max(w * 0.75, Math.min(natural, avail)));
        root.style.setProperty('--pdp-m-gal-h', h + 'px');
        root.classList.add('has-m-gal-h');
      };
      setMobileGallery(true);
      window.addEventListener('resize', function () { setMobileGallery(false); });
      window.addEventListener('load', function () { setMobileGallery(true); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { setMobileGallery(true); });
      window.addEventListener('load', setGalleryOffset);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(setGalleryOffset);
    }

    // ----- Galería tipo Sezane -----
    // Escritorio: miniaturas + flechas cambian la foto principal (fundido).
    // Móvil (<990): carrusel con scroll-snap y puntos. El índice activo se
    // conserva al cambiar de modo.
    if (gal) {
      var slides = Array.prototype.slice.call(gal.querySelectorAll('[data-pdp-slide]'));
      var thumbsBox = root.querySelector('[data-pdp-thumbs]');
      var thumbsView = root.querySelector('[data-pdp-thumbs-viewport]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));
      var tPrev = root.querySelector('[data-pdp-thumbs-prev]');
      var tNext = root.querySelector('[data-pdp-thumbs-next]');
      var nPrev = root.querySelector('[data-pdp-nav-prev]');
      var nNext = root.querySelector('[data-pdp-nav-next]');
      var dotsTrack = root.querySelector('[data-pdp-dots-track]');
      var dots = dotsTrack ? Array.prototype.slice.call(dotsTrack.children) : [];
      var galMq = window.matchMedia('(max-width: 989px)');
      var DOTS_WINDOW = 7;
      var DOT_STEP = 10; // ancho (6) + márgenes (2 + 2)
      var galIdx = 0;

      var renderDots = function () {
        if (!dots.length) return;
        var n = dots.length;
        var start = Math.max(0, Math.min(galIdx - Math.floor(DOTS_WINDOW / 2), n - DOTS_WINDOW));
        var end = start + DOTS_WINDOW - 1;
        dotsTrack.style.transform = 'translateX(' + -start * DOT_STEP + 'px)';
        dots.forEach(function (d, i) {
          var scale = 1;
          if (i < start || i > end) scale = 0;
          else if (start > 0 && i === start) scale = 0.5;
          else if (start > 0 && i === start + 1) scale = 0.75;
          else if (end < n - 1 && i === end) scale = 0.5;
          else if (end < n - 1 && i === end - 1) scale = 0.75;
          d.style.setProperty('--dot-scale', scale);
          d.classList.toggle('is-active', i === galIdx);
        });
      };

      var keepThumbVisible = function (thumb) {
        if (!thumbsView || !thumb) return;
        var top = thumb.offsetTop;
        var bottom = top + thumb.offsetHeight;
        var viewTop = thumbsView.scrollTop;
        var viewBottom = viewTop + thumbsView.clientHeight;
        if (top < viewTop) thumbsView.scrollTop = top;
        else if (bottom > viewBottom) thumbsView.scrollTop = bottom - thumbsView.clientHeight;
      };

      var setGalleryIndex = function (i, fromScroll) {
        if (!slides.length) return;
        i = Math.max(0, Math.min(i, slides.length - 1));
        galIdx = i;
        slides.forEach(function (sl, k) {
          sl.classList.toggle('is-active', k === i);
          if (k !== i) sl.classList.remove('is-hint-open');
        });
        thumbs.forEach(function (t, k) {
          var on = k === i;
          t.classList.toggle('is-active', on);
          if (on) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
        if (resetInlineZoom) resetInlineZoom();
        if (nPrev) nPrev.disabled = i === 0;
        if (nNext) nNext.disabled = i === slides.length - 1;
        keepThumbVisible(thumbs[i]);
        renderDots();
        if (galMq.matches && !fromScroll) {
          gal.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        }
      };

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          setGalleryIndex(parseInt(t.getAttribute('data-pdp-thumb'), 10) || 0);
        });
      });
      if (nPrev) nPrev.addEventListener('click', function (e) { e.stopPropagation(); setGalleryIndex(galIdx - 1); });
      if (nNext) nNext.addEventListener('click', function (e) { e.stopPropagation(); setGalleryIndex(galIdx + 1); });

      // Flechas de miniaturas: solo aparecen si hay miniaturas ocultas en esa
      // dirección, y desplazan la lista una miniatura.
      var thumbsListEl = thumbsBox ? thumbsBox.querySelector('.apodemia-pdp__thumbs-list') : null;
      var updateThumbArrows = function () {
        if (!thumbsView) return;
        // ¿Hacen falta flechas? Se compara la lista con el alto total de la columna
        if (thumbsBox && thumbsListEl) {
          thumbsBox.classList.toggle('is-scrollable', thumbsListEl.scrollHeight > thumbsBox.clientHeight + 1);
        }
        var top = thumbsView.scrollTop;
        var max = thumbsView.scrollHeight - thumbsView.clientHeight;
        if (tPrev) tPrev.hidden = top <= 2;
        if (tNext) tNext.hidden = max - top <= 2;
      };
      var thumbStep = function () {
        var t = thumbs[0];
        return t ? t.offsetHeight + 10 : thumbsView.clientHeight / 2;
      };
      if (thumbsView) {
        thumbsView.addEventListener('scroll', updateThumbArrows, { passive: true });
        window.addEventListener('resize', updateThumbArrows);
        if (window.ResizeObserver) new ResizeObserver(updateThumbArrows).observe(thumbsView);
        if (tPrev) tPrev.addEventListener('click', function () { thumbsView.scrollTop -= thumbStep(); });
        if (tNext) tNext.addEventListener('click', function () { thumbsView.scrollTop += thumbStep(); });
        updateThumbArrows();
      }

      // Flechas del teclado dentro de la galería o las miniaturas (escritorio).
      [gal, thumbsBox].forEach(function (el) {
        if (!el) return;
        el.addEventListener('keydown', function (e) {
          if (galMq.matches) return;
          var back = e.key === 'ArrowLeft' || e.key === 'ArrowUp';
          var fwd = e.key === 'ArrowRight' || e.key === 'ArrowDown';
          if (!back && !fwd) return;
          e.preventDefault();
          setGalleryIndex(galIdx + (fwd ? 1 : -1));
          var t = thumbs[galIdx];
          if (t && el === thumbsBox) t.focus();
        });
      });

      // Móvil: el scroll del carrusel marca la imagen activa.
      var scrollRaf = 0;
      gal.addEventListener('scroll', function () {
        if (!galMq.matches || scrollRaf) return;
        scrollRaf = requestAnimationFrame(function () {
          scrollRaf = 0;
          var w = gal.clientWidth || 1;
          var i = Math.round(gal.scrollLeft / w);
          if (i !== galIdx) setGalleryIndex(i, true);
        });
      }, { passive: true });

      var onGalMode = function () {
        if (galMq.matches) {
          gal.scrollLeft = slides[galIdx] ? slides[galIdx].offsetLeft : 0;
        } else {
          gal.scrollLeft = 0;
        }
      };
      galMq.addEventListener('change', onGalMode);

      // ----- Zoom en la propia foto (escritorio con ratón) -----
      // Cursor circular con "+" que sigue al ratón; clic amplía la foto activa
      // y la desplaza con el ratón; otro clic o salir de la foto la reduce.
      var stage = root.querySelector('.apodemia-pdp__gallery-stage');
      var cursorEl = root.querySelector('[data-pdp-cursor]');
      var zoomMq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
      var ZOOM_LEVEL = 2.2;
      var resetInlineZoom = null;
      if (stage && cursorEl) {
        var activeZoomable = function () {
          var sl = slides[galIdx];
          return sl && sl.hasAttribute('data-pdp-zoom-open') ? sl : null;
        };
        var setOrigin = function (e) {
          var r = gal.getBoundingClientRect();
          var x = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width));
          var y = Math.max(0, Math.min(1, (e.clientY - r.top) / r.height));
          stage.style.setProperty('--pdp-zx', (x * 100).toFixed(2) + '%');
          stage.style.setProperty('--pdp-zy', (y * 100).toFixed(2) + '%');
          var sr = stage.getBoundingClientRect();
          stage.style.setProperty('--pdp-cx', (e.clientX - sr.left) + 'px');
          stage.style.setProperty('--pdp-cy', (e.clientY - sr.top) + 'px');
        };
        var zoomOut = function () {
          stage.classList.remove('is-zoomed');
        };
        resetInlineZoom = function () {
          zoomOut();
          stage.classList.toggle('is-zoomable', zoomMq.matches && !!activeZoomable());
        };
        // Pide una imagen más grande del srcset al ampliar (evita que se pixele).
        var upgradeRes = function (sl) {
          var img = sl.querySelector('img');
          if (!img || img.dataset.pdpZoomSized) return;
          img.dataset.pdpZoomSized = '1';
          img.sizes = Math.round(gal.clientWidth * ZOOM_LEVEL) + 'px';
        };
        stage.style.setProperty('--pdp-zoom-level', ZOOM_LEVEL);

        stage.addEventListener('mouseenter', function (e) {
          if (!zoomMq.matches || !activeZoomable()) return;
          stage.classList.add('is-zoomable');
          setOrigin(e);
          stage.classList.add('is-cursor-on');
        });
        stage.addEventListener('mousemove', function (e) {
          if (!zoomMq.matches || !activeZoomable()) return;
          if (e.target.closest('.apodemia-pdp__nav')) {
            stage.classList.remove('is-cursor-on');
            return;
          }
          if (!stage.classList.contains('is-cursor-on')) stage.classList.add('is-zoomable', 'is-cursor-on');
          setOrigin(e);
        });
        stage.addEventListener('mouseleave', function () {
          stage.classList.remove('is-cursor-on', 'is-pressing');
          zoomOut();
          stage.style.removeProperty('--pdp-zx');
          stage.style.removeProperty('--pdp-zy');
        });
        stage.addEventListener('mousedown', function (e) {
          if (e.target.closest('.apodemia-pdp__nav')) return;
          if (zoomMq.matches && activeZoomable()) stage.classList.add('is-pressing');
        });
        stage.addEventListener('mouseup', function () {
          stage.classList.remove('is-pressing');
        });
        stage.addEventListener('click', function (e) {
          if (!zoomMq.matches || e.target.closest('.apodemia-pdp__nav')) return;
          var sl = activeZoomable();
          if (!sl) return;
          setOrigin(e);
          if (!stage.classList.contains('is-zoomed')) upgradeRes(sl);
          stage.classList.toggle('is-zoomed');
        });
        // Teclado: Enter/Espacio sobre la foto amplía desde el centro.
        gal.addEventListener('keydown', function (e) {
          if (!zoomMq.matches || (e.key !== 'Enter' && e.key !== ' ')) return;
          var sl = activeZoomable();
          if (!sl) return;
          e.preventDefault();
          stage.style.setProperty('--pdp-zx', '50%');
          stage.style.setProperty('--pdp-zy', '50%');
          if (!stage.classList.contains('is-zoomed')) upgradeRes(sl);
          stage.classList.add('is-zoomable');
          stage.classList.toggle('is-zoomed');
        });
        zoomMq.addEventListener('change', resetInlineZoom);
      }

      setGalleryIndex(0, true);
    }

    // ----- "Ver más" de las pestañas de texto (si el contenido desborda) -----
    var clamps = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-clamp]'));
    var checkClamps = function () {
      clamps.forEach(function (clamp) {
        var readmore = clamp.parentNode.querySelector('[data-pdp-readmore]');
        if (!readmore || !clamp.offsetParent || clamp.classList.contains('is-open')) return;
        var overflows = clamp.scrollHeight > clamp.clientHeight + 4;
        readmore.hidden = !overflows;
        clamp.classList.toggle('is-fits', !overflows);
      });
    };
    clamps.forEach(function (clamp) {
      var readmore = clamp.parentNode.querySelector('[data-pdp-readmore]');
      if (!readmore) return;
      readmore.addEventListener('click', function () {
        clamp.style.setProperty('--clamp-full', clamp.scrollHeight + 'px');
        var open = clamp.classList.toggle('is-open');
        readmore.textContent = readmore.getAttribute(open ? 'data-less' : 'data-more');
        readmore.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    if (clamps.length) {
      checkClamps();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(checkClamps);
      window.addEventListener('resize', checkClamps);
      root.addEventListener('pdp:tab-change', checkClamps);
    }

    // ----- Reseña expandible (clic / teclado; hover lo cubre el CSS) -----
    var review = root.querySelector('[data-pdp-review]');
    if (review) {
      var toggle = function () { review.classList.toggle('is-open'); };
      review.addEventListener('click', toggle);
      review.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    }

    // ----- "Ver en idioma original" (solo en locales != es con original) -----
    var reviewOrigBtn = root.querySelector('[data-pdp-review-orig]');
    if (review && reviewOrigBtn) {
      var showingOriginal = false;
      var translated = review.getAttribute('data-review-translated') || review.textContent;
      var original = review.getAttribute('data-review-original') || '';
      reviewOrigBtn.addEventListener('click', function () {
        showingOriginal = !showingOriginal;
        review.textContent = showingOriginal ? original : translated;
        reviewOrigBtn.textContent = showingOriginal
          ? (reviewOrigBtn.getAttribute('data-label-translated') || reviewOrigBtn.textContent)
          : (reviewOrigBtn.getAttribute('data-label-original') || reviewOrigBtn.textContent);
        review.classList.remove('is-open'); // re-recorta al cambiar de texto
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-pdp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init al recargar la sección en el theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-pdp]');
    if (root) init(root);
  });
})();

/* ==========================================================================
 * Columna sticky del PDP — la MÁS CORTA se queda fija (Apodemia)
 * En escritorio (2 columnas) se compara el alto de galería (izquierda) vs info
 * (derecha) y se marca la más corta con .is-pdp-sticky (CSS: position:sticky).
 * Así, al scrollear la columna larga, la corta acompaña. En móvil (1 columna)
 * no aplica. Autónomo; se recalcula al redimensionar y al cargar imágenes.
 * ========================================================================== */
(function () {
  'use strict';
  var MOBILE = 990; // <=989 apila (sin sticky)

  function headerH() {
    var h = document.querySelector('.apodemia-header-wrap');
    return h ? Math.round(h.getBoundingClientRect().height) : 0;
  }

  function apply(inner) {
    var left = inner.querySelector('.apodemia-pdp__left');
    var right = inner.querySelector('.apodemia-pdp__right');
    if (!left || !right) return;
    left.classList.remove('is-pdp-sticky');
    right.classList.remove('is-pdp-sticky');
    inner.style.removeProperty('--pdp-sticky-top');
    if (window.innerWidth < MOBILE) return; // móvil: apilado, sin sticky

    // Lado forzado desde el ajuste de la sección (look: galería fija).
    var section = inner.closest('.apodemia-pdp');
    var side = (section && section.getAttribute('data-pdp-sticky-side')) || 'auto';

    var target;
    if (side === 'left') {
      target = left;
    } else if (side === 'right') {
      target = right;
    } else {
      // Auto: la más corta. Si son casi iguales no fijamos nada (evita saltos).
      var lh = left.getBoundingClientRect().height;
      var rh = right.getBoundingClientRect().height;
      if (Math.abs(lh - rh) < 24) return;
      target = lh < rh ? left : right;
    }
    inner.style.setProperty('--pdp-sticky-top', (headerH() + 16) + 'px');
    target.classList.add('is-pdp-sticky');
  }

  function boot() {
    var inners = document.querySelectorAll('.apodemia-pdp__inner');
    if (!inners.length) return;
    inners.forEach(apply);
  }

  function schedule() {
    window.requestAnimationFrame(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('load', schedule); // tras cargar imágenes (altura real)
  var t = 0;
  window.addEventListener('resize', function () {
    window.clearTimeout(t);
    t = window.setTimeout(schedule, 150);
  });
  document.addEventListener('shopify:section:load', schedule);
})();

// ============================================================
// Visor "Ver en detalle" de la galería PDP
// Clic/Enter en una imagen -> visor a pantalla completa.
// Escritorio: lupa circular que sigue el cursor (x2.5).
// Móvil: pellizco para zoom (x1-x4), arrastre para mover y
// doble tap para alternar x1/x2.5. Esc/flechas en teclado.
// ============================================================
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-pdp-zoom]');
    var dataEl = document.querySelector('[data-pdp-zoom-data]');
    if (!root || !dataEl || root.hasAttribute('data-zoom-init')) return;
    root.setAttribute('data-zoom-init', '');

    // La galería vive en una columna sticky (stacking context propio): el visor
    // se saca a <body> para que su z-index compita a nivel de documento.
    document.body.appendChild(root);

    var imgs = [];
    try { imgs = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!imgs.length) return;

    var stage = root.querySelector('[data-pdp-zoom-stage]');
    var img = root.querySelector('[data-pdp-zoom-img]');
    var lens = root.querySelector('[data-pdp-zoom-lens]');
    var count = root.querySelector('[data-pdp-zoom-count]');
    var btnClose = root.querySelector('[data-pdp-zoom-close]');
    var btnPrev = root.querySelector('[data-pdp-zoom-prev]');
    var btnNext = root.querySelector('[data-pdp-zoom-next]');
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    var LENS = 200; // diámetro de la lupa (px)
    var Z = 2.5;    // aumento de la lupa / doble tap

    var idx = 0;
    var opener = null;

    if (imgs.length < 2) {
      btnPrev.hidden = true;
      btnNext.hidden = true;
      if (count) count.hidden = true;
    }

    // ---- estado táctil (transform sobre la imagen) ----
    var scale = 1, tx = 0, ty = 0;
    function applyT() { img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; }
    function resetT() { scale = 1; tx = 0; ty = 0; applyT(); }
    function clampPan() {
      var r = stage.getBoundingClientRect();
      var mx = Math.max(0, (img.clientWidth * scale - r.width) / 2);
      var my = Math.max(0, (img.clientHeight * scale - r.height) / 2);
      tx = Math.min(mx, Math.max(-mx, tx));
      ty = Math.min(my, Math.max(-my, ty));
    }
    // Re-escala manteniendo fijo el punto (px,py) de la pantalla.
    function setScaleAround(px, py, ns) {
      var r = img.getBoundingClientRect();
      var cx = r.left + r.width / 2;
      var cy = r.top + r.height / 2;
      var ux = (px - cx) / scale;
      var uy = (py - cy) / scale;
      tx += (px - ux * ns) - cx;
      ty += (py - uy * ns) - cy;
      scale = ns;
      clampPan();
      applyT();
    }

    function show(i) {
      idx = (i + imgs.length) % imgs.length;
      img.src = imgs[idx].src;
      img.alt = imgs[idx].alt || '';
      resetT();
      lens.hidden = true;
      if (count) count.textContent = (idx + 1) + ' / ' + imgs.length;
    }
    function open(i, from) {
      opener = from || null;
      show(i);
      root.hidden = false;
      document.documentElement.setAttribute('data-zoom-open', 'true');
      btnClose.focus();
    }
    function close() {
      root.hidden = true;
      document.documentElement.removeAttribute('data-zoom-open');
      if (opener && opener.focus) opener.focus();
    }

    // Abrir desde la galería en DOS pasos: el primer clic/tap muestra la
    // pastilla "Ver en detalle" (is-hint-open); el segundo (en la imagen o en
    // la pastilla) abre el visor. Igual en escritorio y móvil.
    function closeHints(except) {
      document.querySelectorAll('[data-pdp-zoom-open].is-hint-open').forEach(function (o) {
        if (o !== except) o.classList.remove('is-hint-open');
      });
    }
    // En escritorio con ratón el zoom es en la propia foto (sin visor).
    var inlineZoomMq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
    document.querySelectorAll('[data-pdp-zoom-open]').forEach(function (el) {
      function go() { open(parseInt(el.getAttribute('data-pdp-zoom-open'), 10) || 0, el); }
      el.addEventListener('click', function () {
        if (inlineZoomMq.matches) return;
        if (!el.classList.contains('is-hint-open')) {
          closeHints(el);
          el.classList.add('is-hint-open');
          return;
        }
        go();
      });
      // Teclado: Enter/Espacio abren directamente (sin paso intermedio).
      el.addEventListener('keydown', function (e) {
        if (inlineZoomMq.matches) return;
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); }
      });
    });
    // Clic/tap fuera de la galería: se esconde la pastilla.
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-pdp-zoom-open]')) closeHints(null);
    });

    btnClose.addEventListener('click', close);
    btnPrev.addEventListener('click', function () { show(idx - 1); });
    btnNext.addEventListener('click', function () { show(idx + 1); });
    // Clic en el fondo (fuera de la imagen) cierra.
    root.addEventListener('click', function (e) {
      if (e.target === root || e.target === stage) close();
    });
    document.addEventListener('keydown', function (e) {
      if (root.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
    });

    // ---- Lupa (escritorio) ----
    function moveLens(e) {
      var r = img.getBoundingClientRect();
      var x = e.clientX - r.left;
      var y = e.clientY - r.top;
      if (x < 0 || y < 0 || x > r.width || y > r.height) { lens.hidden = true; return; }
      lens.hidden = false;
      lens.style.left = (e.clientX - LENS / 2) + 'px';
      lens.style.top = (e.clientY - LENS / 2) + 'px';
      lens.style.backgroundImage = 'url("' + imgs[idx].src + '")';
      lens.style.backgroundSize = (r.width * Z) + 'px ' + (r.height * Z) + 'px';
      lens.style.backgroundPosition = (LENS / 2 - x * Z) + 'px ' + (LENS / 2 - y * Z) + 'px';
    }
    stage.addEventListener('mousemove', function (e) { if (fine.matches) moveLens(e); });
    stage.addEventListener('mouseleave', function () { lens.hidden = true; });

    // ---- Táctil (móvil): pellizco + arrastre + doble tap ----
    function dist(t) { var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY; return Math.hypot(dx, dy); }
    function mid(t) { return { x: (t[0].clientX + t[1].clientX) / 2, y: (t[0].clientY + t[1].clientY) / 2 }; }
    var pDist = 0, panStart = null, lastTap = 0;

    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        pDist = dist(e.touches);
        panStart = null;
      } else if (e.touches.length === 1) {
        var t = e.touches[0];
        var now = Date.now();
        if (now - lastTap < 300) { // doble tap: alterna zoom
          e.preventDefault();
          if (scale > 1) resetT();
          else setScaleAround(t.clientX, t.clientY, Z);
          lastTap = 0;
          return;
        }
        lastTap = now;
        panStart = { x: t.clientX, y: t.clientY, tx: tx, ty: ty };
      }
    }, { passive: false });

    stage.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2 && pDist) {
        e.preventDefault();
        var d = dist(e.touches);
        var m = mid(e.touches);
        setScaleAround(m.x, m.y, Math.min(4, Math.max(1, scale * (d / pDist))));
        pDist = d;
      } else if (e.touches.length === 1 && panStart && scale > 1) {
        e.preventDefault(); // no arrastrar la página de fondo
        var t = e.touches[0];
        tx = panStart.tx + (t.clientX - panStart.x);
        ty = panStart.ty + (t.clientY - panStart.y);
        clampPan();
        applyT();
      }
    }, { passive: false });

    stage.addEventListener('touchend', function (e) {
      if (e.touches.length < 2) pDist = 0;
      if (!e.touches.length) panStart = null;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
